import logs from './logs'

export default [...logs]
